import React, { useState } from "react"
import { Navigate, Outlet, useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Button } from "antd"
import { isFeatureEnabled } from "config/features"
import { useTheme } from "context/AntdThemeContext"
import { Icon } from "ui/Icon"
import { getLegacyWidgetPath } from "../helpers"
import useEmbedHost from "../useEmbedHost"
import useWidgetCartStorage from "../useWidgetCartStorage"
import ExitConfirmModal from "./ExitConfirmModal"
import StillShoppingModal from "../CartHold/StillShoppingModal"
import styles from "./WidgetLayout.module.css"

// Shell for every #/widget/... screen. Embeds reach these through the old #/embedded/ list and
// detail URLs (see NewWidgetRedirect); a direct #/widget/ link while NEW_BOOKING_WIDGET is off is
// sent back to the matching old screen. When the host page can close the popup, the X top right
// asks to confirm and then tells it to close. The cart is kept across reloads (per guide), and the
// screens show once it is back.
const WidgetLayout = () => {
  const { t } = useTranslation()
  const { uuid, id } = useParams()
  const { isSportsman } = useTheme()
  const { isClosable, requestClose } = useEmbedHost()
  const [isExitOpen, setIsExitOpen] = useState(false)
  const isCartLoaded = useWidgetCartStorage(uuid)

  if (!isFeatureEnabled("NEW_BOOKING_WIDGET")) {
    return <Navigate to={getLegacyWidgetPath({ uuid, id })} replace />
  }

  const brand = isSportsman ? t("select_adventure_mode.sportsman") : t("select_adventure_mode.sportswoman")

  const handleExit = () => {
    setIsExitOpen(false)
    requestClose()
  }

  return (
    <div className={styles.page}>
      {isClosable && (
        <Button
          shape="circle"
          size="large"
          className={styles.closeButton}
          aria-label={t("booking_widget.exit.close")}
          onClick={() => setIsExitOpen(true)}
          icon={<Icon type="feather" name="X" width={20} height={20} color="currentColor" />}
        />
      )}
      <div className={`${styles.content} ${isClosable ? styles.contentClosable : ""}`}>
        {isCartLoaded && <Outlet />}
      </div>
      <a href="https://dspro.guide" target="_blank" rel="noopener noreferrer" className={styles.poweredBy}>
        {t("booking_widget.powered_by", { brand })}
      </a>
      <ExitConfirmModal isOpen={isExitOpen} onContinue={() => setIsExitOpen(false)} onExit={handleExit} />
      {isCartLoaded && <StillShoppingModal />}
    </div>
  )
}

export default WidgetLayout
